import React, { useEffect, useState } from 'react'
import FlightAirlineTable from './FlightAirlineTable'
import CreateFlightAirline from './CreateFlightAirline'
import UpdateFlightAirline from './UpdateFlightAirline'

const FlightAdmin = () => {
  const data = ['fTable', 'fCreate', 'fUpdate']
  const [updateData1, setUpdateData1] = useState(data[0])
  const [getTxnData1, setGetTxnData1] = useState(null)
  console.log('====================================');
  console.log({getTxnData1});
  console.log('====================================');
  let renderdata
  switch (true) {
    case updateData1 === 'fTable':
      renderdata = <FlightAirlineTable setUpdateData1={setUpdateData1} setGetTxnData1={setGetTxnData1} />
      break;
    case updateData1 === 'fCreate':
      renderdata = <CreateFlightAirline setUpdateData1={setUpdateData1} />
      break;
    case updateData1 === 'fUpdate':
      renderdata = <UpdateFlightAirline setUpdateData1={setUpdateData1} getTxnData1={getTxnData1} />
      break;
    default: renderdata = <FlightAirlineTable setUpdateData1={setUpdateData1} setGetTxnData1={setGetTxnData1} />
      break;
  }
  return (
    <div className="row">
      <div className="col-12">
        <h1>Flight Airline</h1>
      </div>
      <hr />
      <div className="col-12">
        {renderdata}

      </div>
    </div>
  )
}

export default FlightAdmin
